import { createContext } from 'react';

export const IsMobileContext = createContext<boolean | undefined>(undefined);
